import React, { FC } from 'react';
import { InputWithValidation } from '../../../../shared/globals';
import { T } from '../../../../shared/helpers';
import { validateRequired } from '../../../../shared/validation';
import { Checkbox } from '../../checkbox';
import { Columns } from '../../columns';
import { FormControl } from '../../formControl';
import { Radio } from '../../radio';
import { units } from '../helpers';

const AreaDesignResizableAreaRightPanel: FC<{
    unit: (typeof units)[number];
    startWidth: string;
    startHeight: string;
    minWidth: string;
    minHeight: string;
    maxWidth: string;
    maxHeight: string;
    keepAspectRatio: boolean;
    lockWidth: boolean;
    lockHeight: boolean;
    enable3DPreview: boolean;

    onStartWidthChange: (value: string) => void;
    onStartHeightChange: (value: string) => void;
    onMinWidthChange: (value: string) => void;
    onMinHeightChange: (value: string) => void;
    onMaxWidthChange: (value: string) => void;
    onMaxHeightChange: (value: string) => void;
    onKeepAspectRatioChange: (value: boolean) => void;
    onLockWidthChange: (value: boolean) => void;
    onLockHeightChange: (value: boolean) => void;
    onEnable3DPreviewChange: (value: boolean) => void;
}> = ({
    unit,
    startWidth,
    startHeight,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    keepAspectRatio,
    lockWidth,
    lockHeight,
    enable3DPreview,

    onStartHeightChange,
    onStartWidthChange,
    onMinHeightChange,
    onMinWidthChange,
    onMaxHeightChange,
    onMaxWidthChange,
    onKeepAspectRatioChange,
    onLockWidthChange,
    onLockHeightChange,
    onEnable3DPreviewChange
}) => {
    return (
        <>
            {' '}
            <FormControl>
                <Checkbox checked={keepAspectRatio} label={`${T._('Keep aspect ratio', 'Admin')}`} onChange={(checked) => onKeepAspectRatioChange(checked)} />
            </FormControl>
            <FormControl label={`${T._('Lock dimension', 'Admin')}`}>
                <Columns $xs={3}>
                    <Radio
                        disabled={keepAspectRatio}
                        name='lockDimension'
                        value='none'
                        label={T._('None', 'Admin')}
                        checked={!lockWidth && !lockHeight}
                        onSelect={() => {
                            onLockWidthChange(false);
                            onLockHeightChange(false);
                        }}
                    />
                    <Radio
                        disabled={keepAspectRatio}
                        name='lockDimension'
                        value='width'
                        label={T._('Width', 'Admin')}
                        checked={lockWidth}
                        onSelect={() => {
                            onLockWidthChange(true);
                            onLockHeightChange(false);
                            onMinWidthChange('');
                            onMaxWidthChange('');
                        }}
                    />
                    <Radio
                        disabled={keepAspectRatio}
                        name='lockDimension'
                        value='none'
                        label={T._('Height', 'Admin')}
                        checked={lockHeight}
                        onSelect={() => {
                            onLockWidthChange(false);
                            onLockHeightChange(true);
                            onMinHeightChange('');
                            onMaxHeightChange('');
                        }}
                    />
                </Columns>
            </FormControl>
            <Columns $xs={2}>
                <FormControl label={`${T._('Start width', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableStartWidth'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={startWidth}
                        onChange={(e) => onStartWidthChange(e.currentTarget.value)}
                    />
                </FormControl>
                <FormControl label={`${T._('Start height', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableStartHeight'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={startHeight}
                        onChange={(e) => onStartHeightChange(e.currentTarget.value)}
                    />
                </FormControl>
            </Columns>
            <Columns $xs={2}>
                <FormControl label={`${T._('Min width', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableMinWidth'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={minWidth}
                        onChange={(e) => onMinWidthChange(e.currentTarget.value)}
                    />
                </FormControl>
                <FormControl label={`${T._('Max width', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableMaxWidth'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={maxWidth}
                        onChange={(e) => onMaxWidthChange(e.currentTarget.value)}
                    />
                </FormControl>
            </Columns>
            <Columns $xs={2}>
                <FormControl label={`${T._('Min height', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableMinHeight'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={minHeight}
                        onChange={(e) => onMinHeightChange(e.currentTarget.value)}
                    />
                </FormControl>
                <FormControl label={`${T._('Max height', 'Admin')} (${unit.value})`}>
                    <InputWithValidation
                        validationKey={'validationResizableMaxHeight'}
                        validate={(value) => validateRequired(value, false) || parseFloat(value) <= 0}
                        message={T._('Required', 'Admin')}
                        type='number'
                        step='0.01'
                        min={0}
                        value={maxHeight}
                        onChange={(e) => onMaxHeightChange(e.currentTarget.value)}
                    />
                </FormControl>
            </Columns>
            <FormControl>
                <Checkbox label={`${T._('Enable 3D Preview', 'Admin')}`} checked={enable3DPreview} onChange={(checked) => onEnable3DPreviewChange(checked)} />
            </FormControl>
        </>
    );
};

export default AreaDesignResizableAreaRightPanel;
